import { createTheme, alpha } from '@mui/material/styles';

// Same structure as kys-platform's theme; palette adapted to the reforestation
// project (forest green / earth). System font stack: the public form is used
// on slow rural mobile networks, no webfont download.
const GREEN = '#1b5e3b';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: GREEN, light: '#2e8b57', dark: '#12402a', contrastText: '#ffffff' },
    secondary: { main: '#a0623a', light: '#c98a5f', dark: '#6e3f22', contrastText: '#ffffff' },
    error: { main: '#c0392b' },
    warning: { main: '#b7791f' },
    info: { main: '#1f5fa8' },
    success: { main: '#2e8b57' },
    background: { default: '#f3f4f6', paper: '#ffffff' },
    text: { primary: '#1f2937', secondary: '#4b5563' },
    divider: '#e5e7eb',
  },
  typography: {
    fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    h1: { fontSize: '1.75rem', fontWeight: 700, letterSpacing: '-0.02em' },
    h2: { fontSize: '1.5rem', fontWeight: 700 },
    h3: { fontSize: '1.25rem', fontWeight: 600 },
    h4: { fontSize: '1.125rem', fontWeight: 600 },
    h5: { fontSize: '1rem', fontWeight: 600 },
    h6: { fontSize: '0.9375rem', fontWeight: 600 },
    body1: { fontSize: '1rem', lineHeight: 1.55 },
    body2: { fontSize: '0.875rem', lineHeight: 1.55 },
    button: { fontWeight: 600, textTransform: 'none' },
  },
  shape: { borderRadius: 10 },
  components: {
    MuiCssBaseline: { styleOverrides: { body: { backgroundColor: '#f3f4f6' } } },
    // 48px touch targets on the public form
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 8, padding: '10px 20px', minHeight: 44 },
        sizeLarge: { minHeight: 48, fontSize: '1rem' },
        contained: { boxShadow: 'none', '&:hover': { boxShadow: `0 4px 12px ${alpha(GREEN, 0.3)}` } },
      },
    },
    MuiCard: { styleOverrides: { root: { borderRadius: 12, border: '1px solid #e5e7eb', boxShadow: '0 1px 3px rgba(0,0,0,0.06)' } } },
    MuiPaper: { styleOverrides: { rounded: { borderRadius: 12 } } },
    MuiTextField: { defaultProps: { variant: 'outlined', fullWidth: true } },
    MuiChip: { styleOverrides: { root: { borderRadius: 6, fontWeight: 600 } } },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& .MuiTableCell-root': { backgroundColor: '#f9fafb', fontWeight: 600, color: '#4b5563', fontSize: '0.8125rem' },
        },
      },
    },
    MuiTableRow: { styleOverrides: { root: { '&:hover': { backgroundColor: alpha(GREEN, 0.03) } } } },
    MuiAlert: { styleOverrides: { root: { borderRadius: 8 } } },
  },
});

export default theme;
